// i18n — locale pe sub-rute: en la root (/finance), ro la /ro/finance, de la /de/finance.
// Ales pentru prerender static: fiecare limbă = HTML propriu, indexabil + hreflang.

export const LOCALES = ['en', 'ro', 'de']
export const DEFAULT_LOCALE = 'en'

// Compat pentru demo-urile portate (foloseau aceste exporturi din vechiul @/i18n):
export const SUPPORTED_LOCALES = LOCALES
export const LOCALE_COOKIE = 'vorba_lang'
export const isLocale = (x) => LOCALES.includes(x)
export const LOCALE_LABELS = { en: 'EN', ro: 'RO', de: 'DE' }
// <html lang> + og:locale corecte per limbă.
export const HTML_LANG = { en: 'en', ro: 'ro', de: 'de' }
export const OG_LOCALE = { en: 'en', ro: 'ro_RO', de: 'de_CH' }

// Limba din pathname: primul segment ro/de → acea limbă; altfel en (default la root).
export function getLocale(pathname) {
  const seg = pathname.split('/')[1]
  return seg === 'ro' || seg === 'de' ? seg : DEFAULT_LOCALE
}

// Pathname „logic" fără prefixul de limbă (ex. /ro/finance → /finance, /de → /).
export function stripLocale(pathname) {
  const seg = pathname.split('/')[1]
  if (seg === 'ro' || seg === 'de') {
    const rest = pathname.slice(3) // taie „/ro" sau „/de"
    return rest === '' ? '/' : rest
  }
  return pathname
}

// Construiește URL-ul pentru o limbă + cale logică. localePath('ro','/finance')='/ro/finance';
// localePath('en','/finance')='/finance'; localePath('de','/')='/de'.
export function localePath(locale, path = '/') {
  const clean = path.startsWith('/') ? path : `/${path}`
  if (locale === DEFAULT_LOCALE) return clean
  return clean === '/' ? `/${locale}` : `/${locale}${clean}`
}
